import React, { useEffect, useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import Map from 'components/Map';
import MapSettings from 'components/Map/settings';
import { MAP_DEFAULT_VAR } from 'types';
import { RootState } from 'redux/root.reducer';
import {
  getECGeocodeStart,
  fetchEmergencyContactsStart,
  clearECData
} from 'redux/emergencyContacts/actions';
import { clearPlaceSuggest } from 'redux/map/actions';
import { CFCProps, MAP_DATA_SERVICE_DATA_SET } from 'types';
import { addPinAndBuffer } from 'components/Map/helper';

const mapStateToProps = ({ emergencyContacts }: RootState) => ({
  locCoordinates: emergencyContacts?.GeoJSONPoints,
  loading: emergencyContacts?.ecLoading,
  ecOrganisations: emergencyContacts?.contacts?.Organisations,
  selectedAddress: emergencyContacts?.geocode?.formattedaddress
});

const connector = connect(mapStateToProps);
type Props = CFCProps<typeof connector> & any;

const { modules } = MapSettings;

const MapView: React.FC<Props> = (props: any) => {
  const { locCoord } = props;
  const extraMapModules = [
    modules.featureLayer,
    modules.geometryEngine,
    modules.point
  ];
  const dispatch = useDispatch();

  const getECData = useCallback(
    (geom: any) => {
      const centroid = {
        latitude: geom.latitude,
        longitude: geom.longitude
      };
      dispatch(
        getECGeocodeStart({
          ...centroid,
          datasets: MAP_DATA_SERVICE_DATA_SET.GEOCODEAU
        })
      );
      dispatch(
        fetchEmergencyContactsStart(`${geom.longitude}, ${geom.latitude}`)
      );
    },
    [dispatch]
  );

  useEffect(() => {
    if (locCoord) {
      const center = locCoord.split(',');
      center.length > 0 && addPinAndBuffer(center);
      const geom = {
        latitude: center[1],
        longitude: center[0]
      };
      getECData(geom);
    }
  }, [locCoord, getECData]);

  const ecCurrentLocCB = (center: any) => {
    const geom = {
      latitude: center[1],
      longitude: center[0]
    };
    getECData(geom);
  };

  const onDropPin = (geom: any) => {
    const centre = [geom.longitude, geom.latitude];
    addPinAndBuffer(centre);
    const center = {
      latitude: geom.latitude,
      longitude: geom.longitude
    };
    getECData(center);
  };

  const resetECContacts = () => {
    dispatch(clearECData());
    dispatch(clearPlaceSuggest());
  };

  return (
    <Map
      fixedBaseMap={MAP_DEFAULT_VAR.BASEMAP}
      extraModules={extraMapModules}
      showDropPinButton={true}
      onDropPin={onDropPin}
      ecCurrentLocCB={ecCurrentLocCB}
      resetECContacts={resetECContacts}
    />
  );
};

export default MapView;
